import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import moment from 'moment';

import pt_BR from '../translations/pt_BR';
import en from '../translations/en';

import 'moment/dist/locale/pt-br';
import 'moment/dist/locale/en-gb';

i18n
  .use(initReactI18next)
  .init({
    lng: 'pt_BR',
    fallbackLng: 'pt_BR',
    interpolation: {
      escapeValue: false,
    },
    resources: {
      pt_BR: { translation: pt_BR },
      en: { translation: en },
    },
  })
  .then(() => {
    const lang = i18n.language.startsWith('pt') ? 'pt-br' : 'en-gb';
    moment.locale(lang);
  });

export default i18n;
